import { ObjectSharing } from '../object-sharing.model';
import { GroupSharingActions, GroupSharingActionTypes } from '../actions/group-sharing.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: ObjectSharing[];
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: []
};

export function reducer(
  state = initialState,
  action: GroupSharingActions
): State {
  switch (action.type) {
    case GroupSharingActionTypes.GetGroupSharingList: {
      return {...state, Loaded: false, Loading: true};
    }

    case GroupSharingActionTypes.AddGroupSharing: {
      return {...state, Loaded: false, Loading: true};
    }

    case GroupSharingActionTypes.UpdateGroupSharing: {
      return {...state, Loaded: false, Loading: true};
    }

    case GroupSharingActionTypes.DeleteGroupSharing: {
      return {...state, Loaded: false, Loading: true};
    }

    case GroupSharingActionTypes.LoadGroupSharingList: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    default: {
      return state;
    }
  }
}

